<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="12">
          <b-form-group
              label="Session"
              label-for="input-3"
              class="custom-label"
              style="color: #bbb3b5"
          >
            {{ sessionId }}
          </b-form-group>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <drop-down-field
                    field-name="Device Type:"
                    field-key="type"
                    :options-json="optionsJSON"
                    :selected-value="sessionType"
                    select-word="Device Type"
                    @selected-option="handleOptionsSelect"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                  label="Name"
                  label-for="input-3"
                  class="custom-label"
              >
                <b-form-input
                    id="input-3"
                    v-model="sessionName"
                    class="custom-input"
                    placeholder="Kitchen"
                    type="text"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-form-group
              label="Email"
              label-for="input-3"
              class="custom-label"
          >
            <b-form-input
                id="input-3"
                v-model="settingsUser.email"
                class="custom-input"
                placeholder="@"
                type="text"
            />
          </b-form-group>
          <b-form-group
              v-if="false"
            description="Select the size of the card grid, including options like 4x4, 6x6, or other grid dimensions. Larger grids can be more challenging."
          >
            <label>Card Grid Size:</label>
            <b-form-spinbutton
              id="match-size"
              v-model="settingsUser.gridSize"
              :min="gridSizeMin"
              :max="gridSizeMax"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group
              label="Smart Detections"
              label-for="input-3"
              class="custom-label"
          >
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import DropDownField from "@/components/blockResources/_components/dropDownField";
import optionsJSON from "../../assets/json/optionsJSON.json";
export default {
  name: "Settings_Glance",
  components: {
    DropDownField
  },
  mixins: [ResourceBlockSettings],
  computed: {
    sessionName: {
      get() {
        let sessionObj = this.getSessionObj();
        return sessionObj &&  sessionObj.name ? sessionObj.name : null;
      },
      set(val) {
        let sessionObj = this.getSessionObj();
        if (!sessionObj) {
          const newSessionObj =  {
            name: val,
            sessionId: this.sessionId,
            _created_at: new Date()
          };
          this.settingsUser.sessions.push(newSessionObj);
        }
        else { //update
          sessionObj.name = val;
          sessionObj._updated_at = new Date();
        }
      }
    },
    sessionType: {
      get() {
        let sessionObj = this.getSessionObj();
        return sessionObj && sessionObj.type ? sessionObj.type : "monitor";
      },
      set(val) {
        let sessionObj = this.getSessionObj();
        if (!sessionObj) {
          const newSessionObj =  {
            type: val,
            sessionId: this.sessionId,
            _created_at: new Date()
          };
          this.settingsUser.sessions.push(newSessionObj);
        }
        else { //update
          sessionObj.type = val;
          sessionObj._updated_at = new Date();
        }
      }
    },
  },
  methods: {
    handleOptionsSelect({key, option}){
      switch (key){
        case 'type':
          this.sessionType = option.value ? option.value : null;
          break;
        default:
          //applog bug
          break;
      }
      this.handleSettingsUserChange();
    }
  },
  data() {
    return {
      optionsJSON,
      settingsUser: {
        sessions: this.settings && this.settings.user && this.settings.user.sessions
            ? this.settings.user.sessions
            : [],
        storageType: null,
        email:  this.settings && this.settings.user && this.settings.user.email
            ? this.settings.user.email
            : null,
        detections:[],
        services:[],
        gridSize:
          this.settings && this.settings.user && this.settings.user.gridSize
            ? this.settings.user.gridSize
            : 2,
        deviceType:
          this.settings && this.settings.user && this.settings.user.deviceType
            ? this.settings.user.deviceType
            : "camera",
        _isSoundOn:
          this.settings &&
          this.settings.user &&
          this.settings.user._isSoundOn !== undefined
            ? this.settings.user._isSoundOn
            : true,
        _hasBGMusic:
          this.settings &&
          this.settings.user &&
          this.settings.user._hasBGMusic !== undefined
            ? this.settings.user._hasBGMusic
            : true,
        _isDisplayStats:
          this.settings &&
          this.settings.user &&
          this.settings.user._isDisplayStats !== undefined
            ? this.settings.user._isDisplayStats
            : true
      },
      toggles: [
        {
          name: "Falls",
          description: "Sound effects during gameplay",
          property: "_detectFalls",
          type: "btns",
          text: "Fall Detection",
          isAvail: true,
          value: true
        },
        {
          name: "Seizures",
          description: "Play Background Music during GamePlay",
          property: "_detectSeizures",
          type: "btns",
          text: "Seizure Detection",
          isAvail: true,
          value: false
        },
        {
          name: "Activity Detection",
          description: "The camera can detect and track various activities such as sitting, standing, walking, or sleeping.",
          property: "_detectActivity",
          type: "btns",
          text: "Activity Detection",
          isAvail: true,
          value: true
        }
      ],
      //****** App Specific
      gridSizeMin: 2,
      gridSizeMax: 5
    };
  }
};
</script>

<style lang="scss" scoped></style>
